import { SET_SHOULD_SHOW_SCHEDULED_ORDERING } from 'shared/app/state/action-creators/types';

const defaultState = {
  shouldShowScheduledOrdering: false,
};

// eslint-disable-next-line complexity,max-statements
export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_SHOULD_SHOW_SCHEDULED_ORDERING: {
      return {
        ...state,
        shouldShowScheduledOrdering: action.payload,
      };
    }

    default:
      return state;
  }
};
